import React from 'react'

export default function Hero() {
  return (
    <div>Hero</div>
  )
}
